import DisplayPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/yesNo/components/YesNoDisplayPart';
import FormPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/yesNo/components/YesNoFormPart';

export default {
  DisplayPart,
  FormPart,
};
